// src/App.jsx

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import "./styles/global.css";

// Importar el Provider de Autenticación
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Componentes públicos
import Navbar from "./components/Navbar";
import Home from "./pages/home";
import Nosotros from "./pages/nosotros";
import Directorio from "./pages/Directorio";
import ComitesTecnicos from "./pages/ComitesTecnicos";
import RepDivisionesTecnicas from "./pages/RepDivisionesTecnicas";
import Noticias from "./pages/Noticias";
import NoticiaDetalle from "./pages/NoticiaDetalle";
import Cursos from "./pages/Cursos";
import CursoDetalle from "./pages/CursoDetalle"
import Eventos from "./pages/Eventos";
import EventoDetalle from "./pages/EventoDetalle"

import Contacto from "./pages/Contacto";
import Login from "./pages/Login";
import PrimerAcceso from "./pages/PrimerAcceso";
import RecuperarPassword from "./pages/RecuperarPassword";
import RegistroSocios from "./pages/RegistroSocios";
import GuiaSocios from "./pages/GuiaSocios";
import SocioPublico from "./pages/SocioPublico";

// Componentes del Dashboard (protegidos)
import DashboardLayout from "./pages/Dashboard/DashboardLayout";

function App() {
  return (
    // 🔐 Envolvemos toda la app con el AuthProvider
    <AuthProvider>
      <Router>
        <Navbar />
        <Routes>
          {/* ✅ RUTAS PÚBLICAS */}
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/nosotros/directorio" element={<Directorio />} />
          <Route path="/comites-tecnicos" element={<ComitesTecnicos />} />
          <Route path="/nosotros/rep-divisiones-tecnicas" element={<RepDivisionesTecnicas />} />
          <Route path="/nosotros/guiasocios" element={<GuiaSocios />} />
          <Route path="/noticias" element={<Noticias />} />
          <Route path="/noticias/:id" element={<NoticiaDetalle />} />
          <Route path="/cursos" element={<Cursos />} />
          <Route path="/cursos/:id" element={<CursoDetalle />} />
          <Route path="/eventos" element={<Eventos />} />
          <Route path="/eventos/:id" element={<EventoDetalle />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/solicitud-registro-socios" element={<Contacto />} />
          <Route path="/login" element={<Login />} />
          <Route path="/primer-acceso" element={<PrimerAcceso />} />
          <Route path="/recuperar-password" element={<RecuperarPassword />} />
          <Route path="/registro-socios" element={<RegistroSocios />} />
          <Route path="/verificar-socio/:id" element={<SocioPublico />} />

          {/* 🛡️ RUTAS PROTEGIDAS DEL DASHBOARD */}
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
